import React, { useEffect, useId, useState } from "react";
import styled from "styled-components";
import { FileUpload, Cancel } from "../../ui/AllImages";
import { Box } from "../../ui/Elements";
const MultipleImageUpload = ({ onImagesChange, initialImages }) => {
    const [images, setImages] = useState(initialImages || []);
    const uniqueId = useId();
    useEffect(() => {
        setImages(initialImages || []);
    }, [initialImages]);
    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        if (files.length > 0) {
            const newImages = [...images, ...files].slice(0, 10); 
            setImages(newImages);
            onImagesChange(newImages);
        }
    };
    const removeImage = (index) => {
        const updatedImages = images.filter((_, i) => i !== index);
        setImages(updatedImages);
        onImagesChange(updatedImages);
    };
    return (
        <ImageUploadContainer>
            <Box className="imagePreviewGrid">
                {images.map((image, index) => (
                    <Box key={index} className="imageThumbnail">
                        <img src={URL.createObjectURL(image)} alt="preview" className="previewImage" />
                        <button className="deleteButton" onClick={() => removeImage(index)}>
                            <Cancel />
                        </button>
                    </Box>
                ))}
                {images.length < 10 && (
                    <Box className="addImageButton" onClick={() => document.getElementById(`imageInput-${uniqueId}`).click()}>
                        <FileUpload size={40} />
                    </Box>
                )}
            </Box>
            <input
                id={`imageInput-${uniqueId}`}
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                multiple
                style={{ display: "none" }}
                onChange={handleFileChange}
            />
        </ImageUploadContainer>
    );
};
export default MultipleImageUpload;
const ImageUploadContainer = styled.div`
    .imageUploadContainer {
        display: flex;
        flex-direction: column;
        /* align-items: center; */
    }
    .imagePreviewGrid {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        /* justify-content: center; */
    }
    .imageThumbnail {
        position: relative;
        width: 120px;
        height: 120px;
        border-radius: 6px;
        overflow: hidden;
        background-color: var(--white);
        border: 1px solid var(--border);
    }
    .previewImage {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .deleteButton {
        position: absolute;
        top: 5px;
        right: 5px;
        background: rgba(255, 0, 0, 0.7);
        color: white;
        border: none;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        svg{
            width: 10px;
            height: 10px;
            [stroke] {
                stroke: var(--white);
            }
            [fill] {
                fill: var(--white);
            }
        }
    }
    .addImageButton {
        width: 120px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        cursor: pointer;
        background-color: var(--white);
        border: 1px solid var(--border);
    }
`